import LogoImg from '../assets/BetRiversLogo.png';


export default function Logo( {state} ){
    return (
        <h1 className="logo">
            <img src={LogoImg} alt="Bet Rivers" />
            {state<=1 && <img src={LogoImg} alt="Bet Rivers" className="logo-sheen" />}
        </h1>
    );
}